import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { VscDebugBreakpointFunction } from "react-icons/vsc";

export const Experience = () => {
  const [moreLess, setMoreLess] = useState({
    one: true,
    two: true,
    three: true,
    four: true,
  });
  const handleSeeMore = (jobNumber) => {
    console.log(jobNumber);
    setMoreLess({
      ...moreLess,
      [jobNumber]: false,
    });
  };
  const handleSeeLess = (jobNumber) => {
    setMoreLess({
      ...moreLess,
      [jobNumber]: true,
    });
  };
  return (
    <section className="experience">
      <Container>
        <div className="row">
          <h1 className="featured-head">Experience</h1>
        </div>
        <Row className="aligh-items-center">
          <Col>
            <h5 className="iDo1">Full Stack Developer</h5>
            <h6>Mobirevo </h6>
            <p
              style={{
                fontSize: "10px",
                margin: "-5px 0px 5px 0px",
                padding: "0px",
              }}
            >
              Lithuania - Remote ( Dec 2024 – Current )
            </p>
            <p class="desc">
              • Played a key role in migrating Stretto legacy website to a React
              web app, enhancing solutions for corporate restructuring and
              financial transactions, resulting in improved user experience and
              functionality.{" "}
              <span
                className="seeMore"
                style={{ color: "lightgray", display: "inline" }}
                onClick={() => handleSeeMore("one")}
              >
                {moreLess.one && "more..."}
              </span>{" "}
              <br />{" "}
              <p className={moreLess.one ? "extraDetail" : ""}>
                {" "}
                • Implemented key backend features with .NET MVC, boosting
                system performance by 60% and seamlessly integrating with MySQL
                database, enhancing financial services functionalities.
                <br />
                • Actively participated in code reviews, offering constructive
                feedback and implementing optimizations to enhance the code
                quality, maintainability, and performance.
                <br />• Increased productivity by 20% through the application of
                active listening skills, fostering better collaboration and
                understanding among colleagues during project discussions and
                task execution.
                <span
                  className="seeMore"
                  style={{ color: "lightgray", display: "inline" }}
                  onClick={() => handleSeeLess("one")}
                >
                  {!moreLess.one && "less"}
                </span>
              </p>
            </p>
            {/* <VscDebugBreakpointFunction /> */}
          </Col>
        </Row>
        <Row className="aligh-items-center">
          <Col>
            <h5 className="iDo1">AI Engineer</h5>
            <h6>GoodCore Inc. </h6>
            <p
              style={{
                fontSize: "10px",
                margin: "-5px 0px 5px 0px",
                padding: "0px",
              }}
            >
              United Kingdom - Remote ( Jan 2024 – Nov 2024 )
            </p>
            <p class="desc">
               •Lead a team focused on developing AI-driven solutions for automated document classification and sentiment
analysis in legal text.
              <span
                className="seeMore"
                style={{ color: "lightgray", display: "inline" }}
                onClick={() => handleSeeMore("two")}
              >
                {moreLess.two && "more..."}
              </span>{" "}
              <br />{" "}
              <p className={moreLess.two ? "extraDetail" : ""}>
                {" "}
                • Utilized NLP techniques, including Named Entity Recognition (NER) and topic modeling, to extract key insights
from unstructured legal documents.
                <br />
                 •  Designed and implemented deep learning models for text classification using BERT and GPT-3, significantly
improving accuracy in classification tasks.

                <br /> • Applied model performance evaluation techniques, including AUC-ROC and confusion matrices, to assess and
optimize model predictions.
                 <br />
                 • Optimized model performance by employing various evaluation metrics such as <strong> AUC-ROC, precision-recall
curves, confusion matrices, and cross-validation </strong>, resulting in highly accurate predictions, especially on
imbalanced datasets.


                <span
                  className="seeMore"
                  style={{ color: "lightgray", display: "inline" }}
                  onClick={() => handleSeeLess("two")}
                >
                  {!moreLess.two && "less"}
                </span>
              </p>
            </p>
            {/* <VscDebugBreakpointFunction /> */}
          </Col>
        </Row>
        <Row className="aligh-items-center">
          <Col>
            <h5 className="iDo1">Computer Vision Engineer</h5>
            <h6>GoodCore Inc. </h6>
            <p
              style={{
                fontSize: "10px",
                margin: "-5px 0px 5px 0px",
                padding: "0px",
              }}
            >
              Pakistan - ( Oct 2021 – Jan 2023 )
            </p>
            <p class="desc">
              • Developed an end-to-end face recognition system using OpenCV and deep learning, enabling automatic
identification in video surveillance footage.
              <span
                className="seeMore"
                style={{ color: "lightgray", display: "inline" }}
                onClick={() => handleSeeMore("three")}
              >
                {moreLess.three && "more..."}
              </span>{" "}
              <br />{" "}
              <p className={moreLess.three ? "extraDetail" : ""}>
                {" "}
                • Integrated object detection models such as YOLOv5 for real-time object recognition and tracking in CCTV video
feeds.
                <br /> • Optimized image processing pipelines for noise reduction and image enhancement, improving model
performance in low-light conditions.
                <br /> • Implemented and deployed models in production environments, working with real-time data pipelines and edge
devices.
                <span
                  className="seeMore"
                  style={{ color: "lightgray", display: "inline" }}
                  onClick={() => handleSeeLess("three")}
                >
                  {!moreLess.three && "less"}
                </span>
              </p>
            </p>
            {/* <VscDebugBreakpointFunction /> */}
          </Col>
        </Row>
        <Row className="aligh-items-center">
          <Col>
            <h5 className="iDo1">Frontend Developer</h5>
            <h6>Freelance </h6>
            <p
              style={{
                fontSize: "10px",
                margin: "-5px 0px 5px 0px",
                padding: "0px",
              }}
            >
              Pakistan - (Oct 2019 – Sep 2020 )
            </p>
            <p class="desc">
              • Specialize in crafting visually appealing and responsive web
              interfaces using HTML, CSS, and JavaScript to exceed client
              expectations.
              <span
                className="seeMore"
                style={{ color: "lightgray", display: "inline" }}
                onClick={() => handleSeeMore("four")}
              >
                {moreLess.four && "more..."}
              </span>{" "}
              <br />{" "}
              <p className={moreLess.four ? "extraDetail" : ""}>
                • Keep abreast of the latest tech trends, infusing projects with
                design flair and ensuring seamless functionality across
                browsers, aiming to create immersive digital experiences that
                showcase technical skills and elevate online presence.
                <span
                  className="seeMore"
                  style={{ color: "lightgray", display: "inline" }}
                  onClick={() => handleSeeLess("four")}
                >
                  {!moreLess.four && "less"}
                </span>
              </p>
            </p>
            {/* <VscDebugBreakpointFunction /> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
